// removed by extract-text-webpack-plugin
module.exports = {"btn-disable":"app-pages-Employees-Role-RoleDetail-RoleForm-RoleDelete-__RoleDelete___12VP1"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Role/RoleDetail/RoleForm/RoleDelete/RoleDelete.css
// module id = 2330
// module chunks = 0